import * as Blockly from 'blockly/core';
import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldOperatorDropdown } from '@/(routers)/boards/editor/block/definitions/fields/fieldOperatorDropdown';

const OPERATOR_OPTIONS = [
    { value: 'AND', label: 'かつ', tooltip: 'AND [&&]' },
    { value: 'OR', label: 'または', tooltip: 'OR [||]' },
];

function attachShadowIfEmpty(block: Blockly.Block, inputName: string): void {
    const input = block.getInput(inputName);
    if (!input?.connection || input.connection.targetBlock()) return;
    const shadow = (block.workspace as Blockly.WorkspaceSvg).newBlock('bool');
    shadow.setShadow(true);
    shadow.outputConnection?.connect(input.connection);
    requestAnimationFrame(() => {
        shadow.initSvg();
        shadow.render();
    });
}

defineBlock({
    type: 'logical',
    colour: CATEGORIES.operator.color,
    tooltip: '2つの条件を論理演算します',
    movable: true,
    deletable: true,
    inline: true,
    output: 'Boolean',
    inputs: [
        {
            kind: 'value',
            name: 'A',
            check: 'Boolean',
        },
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    name: 'OP',
                    instance: () => new FieldOperatorDropdown(OPERATOR_OPTIONS),
                },
            ],
        },
        {
            kind: 'value',
            name: 'B',
            check: 'Boolean',
        },
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'label',
                    text: 'が正しい',
                },
            ],
        },
    ],
    onInit(this: Blockly.Block) {
        attachShadowIfEmpty(this, 'A');
        attachShadowIfEmpty(this, 'B');
    },
});
